import type { FC } from 'react';

import {
  FIELD_KEYFRAMES,
  FIELD_MEDIA_TYPE,
  FIELD_TITLE,
  FIELD_TYPES,
} from '@iconik-io/shared-lib/src/constants/search';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import { useAppSelector } from '../../../store/react_redux_typed';
import CheckboxFieldWrapper from '../../../ui/forms/field_wrappers/checkbox/checkbox';
import TableView from '../../../ui/table/table';
import type { Column } from '../../../ui/table/types';

type Props = {
  items: SearchItemEntity[];
  selectedItems: string[];
  onSelect: (id: string, value: boolean) => void;
};

const CreateRelationsTable: FC<Props> = ({
  items,
  onSelect,
  selectedItems,
}) => {
  const breakpoint = useAppSelector((state) => state.displayReducer.breakpoint);

  const renderColumns: Column<SearchItemEntity>[] = [];
  renderColumns.push({
    name: 'id',
    type: FIELD_TYPES.CUSTOM_COMPONENT,
    component: ({ item }) => (
      <CheckboxFieldWrapper
        name={item.id}
        onChange={(value) => {
          onSelect(item.id, value ?? false);
        }}
        value={selectedItems.includes(item.id)}
        aria={{
          label: `Select ${item.title}`,
        }}
      />
    ),
    style: { width: 80 },
  });

  renderColumns.push({
    name: FIELD_KEYFRAMES,
    type: FIELD_TYPES.THUMBNAIL,
  });

  renderColumns.push({
    name: FIELD_TITLE,
    type: FIELD_TYPES.TITLE,
    style: { width: '90%', maxWidth: '100px' },
  });

  if (breakpoint >= 3) {
    renderColumns.push({
      name: FIELD_MEDIA_TYPE,
      type: FIELD_TYPES.MEDIA_ICON,
      style: { width: 80 },
    });
  }

  return (
    <TableView items={items} renderColumns={renderColumns} showHeader={false} />
  );
};

export default CreateRelationsTable;
